// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from 'mergeI18nTranslations';

// we use JSON.parse here instead of just loading it as a javascript object literal
// because according to https://v8.dev/blog/cost-of-javascript-2019#json that is faster
mergeI18nTranslations(JSON.parse("{\"ru\":{\"disabled_not_visible_to_students_2c9d693f\":\"Отключено. Не отображается для студентов.\",\"global_navigation_8bee3501\":\"Глобальная навигация\",\"loading_f99d93d4\":\"... загрузка\",\"no_content_not_visible_to_students_905f8996\":\"Нет содержания. Не отображается для студентов.\"}}"));
